import * as THREE from 'three';
import { CAR } from '../utils/constants';

export type CopLightBarHandle = {
  group: THREE.Group;
  update: (dt: number) => void;
  setPosition: (x: number, y: number, z: number, heading: number) => void;
};

export function createCopLightBar(): CopLightBarHandle {
  const group = new THREE.Group();
  group.name = 'CopLightBar';

  const redGlow = new THREE.Mesh(
    new THREE.BoxGeometry(0.2, 0.12, 0.3),
    new THREE.MeshBasicMaterial({
      color: 0xff0000,
      transparent: true,
      opacity: 0.9,
    }),
  );
  redGlow.position.set(-0.25, CAR.HEIGHT * 0.55, 0);
  group.add(redGlow);

  const blueGlow = new THREE.Mesh(
    new THREE.BoxGeometry(0.2, 0.12, 0.3),
    new THREE.MeshBasicMaterial({
      color: 0x0044ff,
      transparent: true,
      opacity: 0.9,
    }),
  );
  blueGlow.position.set(0.25, CAR.HEIGHT * 0.55, 0);
  group.add(blueGlow);

  let phase = 0;
  const flashSpeed = 8;

  const update = (dt: number) => {
    phase += dt * flashSpeed;
    const flash = Math.sin(phase) > 0;

    const redMat = redGlow.material as THREE.MeshBasicMaterial;
    const blueMat = blueGlow.material as THREE.MeshBasicMaterial;

    redMat.opacity = flash ? 1 : 0.2;
    blueMat.opacity = flash ? 0.2 : 1;
  };

  const setPosition = (x: number, y: number, z: number, heading: number) => {
    group.position.set(x, y, z);
    group.rotation.y = heading;
  };

  return { group, update, setPosition };
}
